const contentTables = document.querySelectorAll('.content table');

const wrap = (toWrap) => {
    const parentEl = toWrap.parentNode;
    if (parentEl.classList.contains('table-wrapper')) {
        return;
    }

    const wrapper = document.createElement('div');
    wrapper.classList.add('table-wrapper');
    parentEl.insertBefore(wrapper, toWrap.nextSibling);
    wrapper.appendChild(toWrap);
};

contentTables.forEach((table) => {
    wrap(table);
});
